// @ts-nocheck
import { infoProps } from "@store/Themes/common/props/info";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const tooltip: Styleguide["tooltip"] = {
    defaultProps: {
        iconProps: {
            ...infoProps.helpIcon,
            css: null as any,
        },
        cssOverrides: {
            tooltipWrapper: css`
                ${infoProps.helpIcon?.css}
                z-index: 1;
            `,
            tooltipClickable: css`
                ${focusStyles()}
                padding: 0;
            `,
            tooltipContainer: css`
                white-space: normal;
            `,
        },
        typographyProps: {
            weight: "normal",
        },
    },
};

export default tooltip;
